<template>
  <div class="app-container" style="background:#f9f9f9">
    <!-- 任务大盘 -->
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>任务大盘</span>
        <el-popover popper-class="gray-popper" placement="right-end" width="260" trigger="hover">
          <div>
            <div>待分配，表示还未确定设计师的状态；</div>
            <div>进行中，表示设计师已经设计中的状态；</div>
            <div>待确认，表示完稿文件待需求方确认；</div>
            <div>已完成，表示需求方已经确认完稿文件；</div>
            <div>已拒绝，表示该需求已被设计师拒绝。</div>
          </div>
          <i class="el-icon-question" slot="reference" style="cursor: pointer;" />
        </el-popover>
      </div>
      <el-row :gutter="60" type="flex" class="panel-group">
        <el-col :span="6" class="card-panel-col" v-for="(item,index) in panelList" :key="index">
          <div class="card-panel" :class="{
                            red: item.id == 0,
                            blue: item.id == 2,
                            purple: item.id == 1,
                            green: item.id == 3,
                            gray: item.id == -1,
                            active: status !== '' && status == item.id,
                        }" @click="handleStatus(item.id)">
            <div class="card-panel-text">{{item.name}}</div>
            <count-to :start-val="0" :end-val="item.total" :duration="2600+index" class="card-panel-num" />
          </div>
        </el-col>
      </el-row>
    </el-card>

    <!-- 任务明细 -->
    <el-card class="box-card" shadow="never" style="margin-top:10px">
      <div slot="header" class="clearfix displayflex">
        <div style="width:100%">任务明细</div>
        <div style="width:140px">
          <el-tooltip placement="top">
            <div slot="content">
              <span v-if="timeValue">点击关闭任务列表自动刷新</span>
              <span v-else>点击开启任务列表自动刷新并返回第一页</span>
            </div>
            <el-switch style="width: 140px;" v-model="timeValue" active-color="#13ce66" inactive-color="#ff4949" :active-text="timeValue?'关闭自动刷新':'开启自动刷新'" @change="intervalTime"></el-switch>
          </el-tooltip>
        </div>
      </div>

      <!-- 工具栏 收搜 -->
      <toolbar-task ref="toolbar" source="pools" @filter="handleFilter" @download="handleDownload"></toolbar-task>

      <!-- 列表 -->
      <table-list ref="table" :status="status" @paginationList="getList" @againList="handleFilter"></table-list>

    </el-card>
  </div>
</template>

<script>
import CountTo from 'vue-count-to'
import ToolbarTask from './components/toolbarTask'
import TableList from './components/tableList'
import { artFlowList_ajax, artFlowStatusNum_ajax, artFlowDown_ajax } from '@File~/api/file'
export default {
  components: { CountTo, ToolbarTask, TableList },
  data() {
    return {
      panelList: [
        {
          id: 0,
          name: '全部待分配',
          total: 0
        },
        {
          id: 2,
          name: '全部进行中',
          total: 0
        },
        {
          id: 1,
          name: '全部待确认',
          total: 0
        },
        {
          id: 3,
          name: '全部已完成',
          total: 0
        },
        {
          id: -1,
          name: '全部已拒绝',
          total: 0
        }
      ],
      status: '', // 状态
      listTime: null, //列表刷新定时器
      timeValue: true,
    }
  },

  created() {
    this.getStatusNum()
  },

  mounted() {
    this.getList()
    var _this = this;

    this.listTime = setInterval(() => {
      _this.$refs['table'].listQuery.pageNo = 1
      _this.getList()
    }, 30000);

  },
  beforeDestroy() {
    if (this.listTime != null) {
      clearInterval(this.listTime)
      this.listTime = null
    }
  },

  methods: {
    intervalTime(val) {
      if (val) {
        var _this = this;
        _this.$refs['table'].listQuery.pageNo = 1
        this.getList()
        this.listTime = setInterval(() => {
          _this.$refs['table'].listQuery.pageNo = 1
          _this.getList()
        }, 30000);
      } else {
        clearInterval(this.listTime)
        this.listTime = null
      }
    },

    // 获取不同状态工单条数
    getStatusNum() {
      const roleIds = this.$store.getters.roles.toString()
      artFlowStatusNum_ajax(roleIds).then(response => {
        if (response.code == 1) {
          response.data.forEach(v => {
            this.panelList.forEach(p => {
              if (v.status == p.id) {
                p.total = v.num
              }
            })
          });
        }
      })
    },

    // 获取列表
    getList() {
      this.getStatusNum()
      const toolbar = this.$refs['toolbar']
      const table = this.$refs['table']
      table.listLoading = true
      const data = {
        pageNo: table.listQuery.pageNo,
        pageSize: table.listQuery.pageSize,
        orderByTypeStr: table.sortType ? table.sortProperty + ' ' + table.sortType : 'createTime DESC',
        keyword: toolbar.search,
        createTime: toolbar.createTimes && toolbar.createTimes.length > 0 ? toolbar.createTimes[0] + ' - ' + toolbar.createTimes[1] : '',
        completeTime: toolbar.finishTimes && toolbar.finishTimes.length > 0 ? toolbar.finishTimes[0] + ' - ' + toolbar.finishTimes[1] : '',
        projectIds: toolbar.projectIds,
        designerIds: toolbar.designerIds,
        priority: toolbar.priority,
        status: this.status,
        taskIds: toolbar.putValue ? toolbar.putValue : [],
        createUserId: null,
        share: toolbar.share,
        roleIds: this.$store.getters.roles,
        taskTypeIds:toolbar.taskTypeIds
      }
      artFlowList_ajax(data).then(response => {
        table.listLoading = false
        if (response.code == 1) {
          table.total = response.data.totalCount
          const data = JSON.parse(JSON.stringify(response.data.result))
          table.tableData = data.map(v => {
            if (this.$store.getters.userId == v.createUserId && v.status == 0) { // 待分配
              this.$set(v, 'isBackout', true) // 撤销按钮
            }

            if (this.$store.getters.userId == v.createUserId) {
              this.$set(v, 'isShare', true)
            }
            return v
          })
        }
      })
    },

    // 查询
    handleFilter() {
      this.$refs['table'].listQuery.pageNo = 1
      this.getList()
    },

    // 下载
    getDownload() {
      const toolbar = this.$refs['toolbar']
      const data = {
        keyword: toolbar.search,
        createTime: toolbar.createTimes && toolbar.createTimes.length > 0 ? toolbar.createTimes[0] + ' - ' + toolbar.createTimes[1] : '',
        completeTime: toolbar.finishTimes && toolbar.finishTimes.length > 0 ? toolbar.finishTimes[0] + ' - ' + toolbar.finishTimes[1] : '',
        projectIds: toolbar.projectIds,
        designerIds: toolbar.designerIds,
        priority: toolbar.priority,
        status: this.status,
        taskIds: toolbar.putValue ? toolbar.putValue : [],
        createUserId: null,
        share: toolbar.share,
        roleIds: this.$store.getters.roles,
        taskTypeIds:toolbar.taskTypeIds
      }

      artFlowDown_ajax(data)
      // .then(response => {
      //     if(response.code == 1) {
      //     }
      // })
    },

    // 下载
    handleDownload() {
      this.getDownload()
    },

    // 切换状态值
    handleStatus(id) {
      if (this.status === id) {
        this.status = ''
      } else {
        this.status = id
      }
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-group {
  flex-flow: row wrap;
  padding: 0 20px;
}
.card-panel-col {
  flex: auto;
  min-width: 227px;
  width: 20%;
  max-width: 20%;
}

.card-panel {
  height: 108px;
  cursor: pointer;
  overflow: hidden;
  padding: 20px;
  border-radius: 8px;
  margin: 10px 0;
  background-image: url("../../assets/panelBg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right bottom;
  &.red {
    background: #ffe9eb;
  }
  &.purple {
    background: #f2ecfe;
  }
  &.blue {
    background: #e3f1fb;
  }
  &.green {
    background: #dbf8ec;
  }
  &.gray {
    background: #eeeeee;
  }

  .card-panel-text {
    line-height: 18px;
    color: rgba(51, 51, 51, 0.85);
    font-size: 16px;
    margin-bottom: 12px;
    font-weight: bold;
  }
  .card-panel-num {
    color: #333333;
    font-size: 20px;
  }

  &.active {
    box-shadow: 0px 4px 10px 4px rgba(0, 0, 0, 0.07),
      0px 3px 5px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -2px rgba(0, 0, 0, 0.12);
  }
}

.box-card {
  border: 0;
  ::v-deep .el-card__header {
    padding: 8px 10px;
    font-weight: bold;
  }
  ::v-deep .el-card__body {
    padding: 10px 20px;
  }
}
.displayflex {
  display: flex;
  justify-content: space-between;
}
</style>
